import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { IconChevronLeft } from '@/components/icons';

/** A labeled key/value row for detail screens (label left/top, value right/bottom). */
export function DetailRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-0.5 border-b border-border py-3 last:border-0 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
      <dt className="text-sm text-text-muted">{label}</dt>
      <dd className="text-sm font-medium text-text-primary sm:text-right">{children}</dd>
    </div>
  );
}

/** Compact "volver" link shown above detail headers. */
export function BackLink({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-1 text-sm text-text-muted transition-colors hover:text-text-primary"
    >
      <IconChevronLeft className="h-4 w-4" />
      {children}
    </Link>
  );
}
